import { Component, ViewChild, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Global } from '../../../shared/global';

const swal = require('sweetalert');

@Component({
  selector: 'app-hoso-nhanvienedit',
  templateUrl: './nhanvienedit.component.html',
  styleUrls: ['./nhanvienedit.component.scss'],
  providers: [ListService, Repository]
})
export class nhanvieneditComponent implements OnInit {
  @Output() save: EventEmitter<any> = new EventEmitter();
  @ViewChild('mafocus', { static: false }) mafocus: any;

  currentUser: any;
  inputchucvus: any[] = [];
  inputphongbans: any[] = [];
  inputgioitinhs: any[] = [
    { Id: 1, Ten: 'Nam' },
    { Id: 0, Ten: 'Nữ' },
    { Id: 2, Ten: 'Khác' }
  ];
  donViIdMacDinh: number = null;
  tenDonVi = '';
  imagePreview: string | SafeUrl = '/assets/img/user.png';
  private imagePreviewRaw = '/assets/img/user.png';
  private loadingAnh = false;
  hasAnh = false;
  xoaAnhFlag = false;
  phongBanSelected: any = null;

  doituongSelect: any = this.emptyModel();

  constructor(
    private _dataService: ListService,
    public repo: Repository,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void { }

  emptyModel() {
    return {
      Id: 0, MaNV: null, HoVaTen: null, GioiTinh: 1, NgaySinh: null, NgaySinh_S: null,
      SoCMND: null, DienThoaiDiDong: null, Email: null,
      DonViId: null, ChucVuId: null, BoPhanId: null,
      CongViecDuocGiao: null, ImageUrl: null,
      LSBT_DiTu: [], LSBT_BanThan: [], LSBT_GiaDinh: [], QTCT: [], QHGD: []
    };
  }

  comboSearchFn(term: string, item: any) {
    term = (term || '').toLowerCase();
    const ma = (item.Ma || '').toLowerCase();
    const ten = (item.Ten || '').toLowerCase();
    return ma.indexOf(term) > -1 || ten.indexOf(term) > -1;
  }

  loadDataInit(id: any, donViId: number, tenDonVi: string) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    this.donViIdMacDinh = donViId;
    this.tenDonVi = tenDonVi || '';
    this.doituongSelect = this.emptyModel();
    this.doituongSelect.DonViId = donViId;
    this.doituongSelect.BoPhanId = null;
    this.phongBanSelected = null;
    this.hasAnh = false;
    this.xoaAnhFlag = false;
    this.setPreview('/assets/img/user.png');

    this.repo.getRequest('api/chucvu/getall').subscribe(res => {
      this.inputchucvus = res || [];
    }, () => {
      this.repo.postRequest('api/chucvu/getall', {}).subscribe(res2 => { this.inputchucvus = res2 || []; });
    });

    this.repo.postRequest('api/hoso/phongban_list', { DonViId: donViId || 0 }).subscribe(res => {
      this.inputphongbans = (res || []).map((x: any) => ({ Ten: x.Ten || x.ten }));
    });

    setTimeout(() => {
      if (this.mafocus && this.mafocus.nativeElement) this.mafocus.nativeElement.focus();
    }, 300);

    if (id != null && id !== '' && id !== 0) {
      this.repo.postRequest('api/hoso/getthongtinhoso/', { Id: String(id), Status: 0 }).subscribe(response => {
        if (!response) return;
        const hosoid = response.Id != null ? response.Id : (response.id != null ? response.id : id);
        this.doituongSelect.Id = hosoid;
        this.doituongSelect.MaNV = response.MaNV != null ? response.MaNV : response.maNV;
        this.doituongSelect.HoVaTen = response.HoVaTen != null ? response.HoVaTen : response.hoVaTen;
        this.doituongSelect.GioiTinh = response.GioiTinh != null ? response.GioiTinh : response.gioiTinh;
        const ngaySinh = response.NgaySinh != null ? response.NgaySinh : response.ngaySinh;
        this.doituongSelect.NgaySinh = ngaySinh ? new Date(ngaySinh) : null;
        this.doituongSelect.SoCMND = response.SoCMND != null ? response.SoCMND : response.soCMND;
        this.doituongSelect.DienThoaiDiDong = response.DienThoaiDiDong != null ? response.DienThoaiDiDong : response.dienThoaiDiDong;
        this.doituongSelect.Email = response.Email != null ? response.Email : response.email;
        const dv = response.DonViId != null ? response.DonViId : response.donViId;
        this.doituongSelect.DonViId = dv != null ? dv : donViId;
        this.doituongSelect.ChucVuId = response.ChucVuId != null ? response.ChucVuId : response.chucVuId;
        this.doituongSelect.BoPhanId = null;
        this.doituongSelect.CongViecDuocGiao = response.CongViecDuocGiao != null ? response.CongViecDuocGiao : response.congViecDuocGiao;
        this.doituongSelect.LSBT_DiTu = response.LSBT_DiTu || response.lsbt_DiTu || [];
        this.doituongSelect.LSBT_BanThan = response.LSBT_BanThan || response.lsbt_BanThan || [];
        this.doituongSelect.LSBT_GiaDinh = response.LSBT_GiaDinh || response.lsbt_GiaDinh || [];
        this.doituongSelect.QTCT = response.QTCT || response.qtct || [];
        this.doituongSelect.QHGD = response.QHGD || response.qhgd || [];
        if (this.doituongSelect.CongViecDuocGiao) {
          this.phongBanSelected = { Ten: this.doituongSelect.CongViecDuocGiao };
        }
        this.doituongSelect.ImageUrl = null;
        this.xoaAnhFlag = false;
        this.hasAnh = false;
        this.loadAnhPreview(hosoid);
      });
    }
  }

  setPreview(url: string) {
    this.imagePreviewRaw = url || '/assets/img/user.png';
    if (this.imagePreviewRaw.indexOf('data:') === 0) {
      this.imagePreview = this.sanitizer.bypassSecurityTrustUrl(this.imagePreviewRaw);
    } else {
      this.imagePreview = this.imagePreviewRaw;
    }
    this.cdr.detectChanges();
  }

  loadAnhPreview(hosoid: any) {
    if (!hosoid) {
      this.setPreview('/assets/img/user.png');
      return;
    }
    this.loadingAnh = true;
    const url = '/api/hoso/showimage/?hosoid=' + hosoid + '&t=' + new Date().getTime();
    const token = this.currentUser && this.currentUser.access_token ? this.currentUser.access_token : '';
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);

    // Chỉ dùng data URL — tránh (error) trên <img> ghi đè khi modal đang mở
    this.http.get(url, { headers: headers, responseType: 'blob' }).subscribe(
      (blob: Blob) => {
        this.loadingAnh = false;
        if (!blob || blob.size < 50) {
          this.setPreview('/assets/img/user.png');
          return;
        }
        if (blob.type && blob.type.indexOf('json') >= 0) {
          this.setPreview('/assets/img/user.png');
          return;
        }
        const mime = (blob.type && blob.type.indexOf('image/') === 0) ? blob.type : 'image/png';
        const imageBlob = new Blob([blob], { type: mime });
        const reader = new FileReader();
        reader.onload = () => {
          let dataUrl = reader.result as string;
          if (!dataUrl) {
            this.hasAnh = false;
            this.setPreview('/assets/img/user.png');
            return;
          }
          if (dataUrl.indexOf('data:image') !== 0) {
            const idx = dataUrl.indexOf(',');
            if (idx > 0) dataUrl = 'data:image/png;base64' + dataUrl.substring(idx);
          }
          // Ảnh mặc định nhỏ — coi như chưa có ảnh hồ sơ
          if (blob.size < 5000) {
            this.hasAnh = false;
            this.setPreview('/assets/img/user.png');
            return;
          }
          this.hasAnh = true;
          this.setPreview(dataUrl);
        };
        reader.onerror = () => this.setPreview('/assets/img/user.png');
        reader.readAsDataURL(imageBlob);
      },
      () => {
        this.loadingAnh = false;
        this.setPreview(url);
      }
    );
  }

  onPhongBanSelect(item: any) {
    if (!item) {
      this.doituongSelect.CongViecDuocGiao = null;
      return;
    }
    if (typeof item === 'string') this.doituongSelect.CongViecDuocGiao = item;
    else if (item.Ten) this.doituongSelect.CongViecDuocGiao = item.Ten;
  }

  onImageError() {
    if (this.loadingAnh) return;
    const raw = this.imagePreviewRaw || '';
    if (raw.indexOf('data:image') === 0) return;
    if (raw.indexOf('user.png') < 0) {
      this.hasAnh = false;
      this.setPreview('/assets/img/user.png');
    }
  }

  xoaAnhClick() {
    swal({
      title: 'Xóa ảnh nhân viên?',
      text: 'Ảnh sẽ bị xóa khi bạn bấm Lưu lại.',
      icon: 'warning',
      buttons: {
        cancel: { text: 'Hủy bỏ', value: false, visible: true },
        confirm: { text: 'Xóa ảnh', value: true, visible: true, className: 'bg-danger', closeModal: true }
      }
    }).then((ok: boolean) => {
      if (!ok) return;
      this.xoaAnhFlag = true;
      this.hasAnh = false;
      this.doituongSelect.ImageUrl = null;
      this.setPreview('/assets/img/user.png');
    });
  }

  addPhongBanTag = (term: string) => ({ Ten: term });

  onFileSelected(event: any) {
    const files = event.target.files;
    if (!files || files.length === 0) return;
    if (!files[0].type.match('image.*')) {
      swal('Lỗi!', 'Tệp chọn không phải kiểu ảnh.', 'error');
      return;
    }
    const localReader = new FileReader();
    localReader.onload = () => {
      if (localReader.result) {
        this.xoaAnhFlag = false;
        this.hasAnh = true;
        this.setPreview(localReader.result as string);
      }
    };
    localReader.readAsDataURL(files[0]);

    const formData = new FormData();
    formData.append('file', files[0], files[0].name);
    const headers = new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer ' + (this.currentUser && this.currentUser.access_token ? this.currentUser.access_token : ''));
    $('#loading').show();
    this.http.post(Global.App_url + 'api/hoso/uploadimage', formData, {
      headers: headers,
      responseType: 'text'
    }).subscribe(
      (res: string) => {
        $('#loading').hide();
        event.target.value = null;
        if (res) {
          const path = res.replace(/^"|"$/g, '');
          this.doituongSelect.ImageUrl = path;
        }
      },
      () => {
        $('#loading').hide();
        swal('Cảnh báo!', 'Không tải được ảnh lên server.', 'warning');
      }
    );
  }

  closeModal() {
    this.save.emit(null);
  }

  toDateS(d: Date): string {
    if (!d) return null;
    const dt = new Date(d);
    return dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
  }

  saveproduct() {
    if (!this.doituongSelect.HoVaTen) {
      swal('Lỗi!', 'Vui lòng nhập họ và tên!', 'error');
      return;
    }
    if (!this.doituongSelect.DonViId) this.doituongSelect.DonViId = this.donViIdMacDinh;
    if (!this.doituongSelect.DonViId) {
      swal('Lỗi!', 'Thiếu đơn vị. Mở lại từ form đơn vị.', 'error');
      return;
    }
    this.doituongSelect.BoPhanId = null;
    if (this.doituongSelect.ChucVuId === 0) this.doituongSelect.ChucVuId = null;
    if (this.doituongSelect.GioiTinh === 2 || this.doituongSelect.GioiTinh == null)
      this.doituongSelect.GioiTinh = 1;

    if (this.phongBanSelected) {
      this.doituongSelect.CongViecDuocGiao = typeof this.phongBanSelected === 'string'
        ? this.phongBanSelected
        : this.phongBanSelected.Ten;
    }
    // Payload sạch — tránh gửi null vào int/DateTime không nullable (InvalidCastException Newtonsoft)
    const payload: any = {
      Id: Number(this.doituongSelect.Id) || 0,
      MaNV: this.doituongSelect.MaNV || null,
      HoVaTen: this.doituongSelect.HoVaTen,
      GioiTinh: (this.doituongSelect.GioiTinh === 0 || this.doituongSelect.GioiTinh === 1)
        ? this.doituongSelect.GioiTinh : 1,
      NgaySinh_S: this.toDateS(this.doituongSelect.NgaySinh),
      SoCMND: this.doituongSelect.SoCMND || null,
      DienThoaiDiDong: this.doituongSelect.DienThoaiDiDong || null,
      Email: this.doituongSelect.Email || null,
      DonViId: Number(this.doituongSelect.DonViId) || 0,
      ChucVuId: this.doituongSelect.ChucVuId ? Number(this.doituongSelect.ChucVuId) : null,
      CongViecDuocGiao: this.doituongSelect.CongViecDuocGiao || null,
      ImageUrl: this.xoaAnhFlag ? null : (this.doituongSelect.ImageUrl || null),
      XoaAnh: this.xoaAnhFlag ? 1 : 0,
      LSBT_DiTu: [],
      LSBT_BanThan: [],
      LSBT_GiaDinh: [],
      QTCT: [],
      QHGD: []
    };

    $('#loading').show();
    this.repo.postRequest('api/hoso/addorupdate_hoso2', payload).subscribe(response => {
      $('#loading').hide();
      if (!response) {
        swal('Cảnh báo!', 'Không nhận được phản hồi từ máy chủ.', 'warning');
        return;
      }
      const status = response.Status || response.status;
      if (status === 'OK') {
        swal('Thành công!', 'Đã lưu nhân viên.', 'success');
        this.save.emit(response.Data || response.data || this.doituongSelect);
      } else {
        swal('Cảnh báo!', status || 'Lưu không thành công', 'warning');
      }
    }, (err) => {
      $('#loading').hide();
      const msg = (err && err.error && (err.error.Message || err.error.message)) || 'Lưu không thành công';
      swal('Lỗi!', msg, 'error');
    });
  }
}
